import { useCompletedLiveDrivers } from './useCompletedLiveDrivers';
import { useRoutesWithTasks } from './useRoutesWithTasks';

export function useCompletedDriversWithTasks() {
    const completedLiveDrivers = useCompletedLiveDrivers();
    return useRoutesWithTasks(completedLiveDrivers);
}
